<template>
    <div class="yd-news-button" @click="newsClick(newsData.newsContentURL)" v-if="newsData.newsContentTitle" v-text="newsData.newsContentTitle"></div>
</template>
<script>
export default {
    props: ["newsData"],
    methods: {
        newsClick(url) {
            this.$emit('newsClick', url);
        },
        //获取当前时间，格式为："2017-5-12 17:59:12"
        getCurrentTime() {
            return new Date().toLocaleString();
        }
    }
}
</script>
<style lang="less">
/*大图新闻*/
.yd-news-button {
    // display: none;
    margin-top: 10px;
    cursor: pointer;
    text-align: center;
    background: #0c9aee;
    color: #ffffff;
    font-size: 14px;
    padding: 10px 0;
    border-radius: 4px;
}
</style>




// WEBPACK FOOTER //
// Button.vue?f612c0fa